import { render, staticRenderFns } from "./beneficiary-mobile-phone.vue?vue&type=template&id=5f1f9247&"
import script from "./beneficiary-mobile-phone.vue?vue&type=script&lang=js&"
export * from "./beneficiary-mobile-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports